import { types, actions } from './requests'
export const DELETESCHEDULE_TYPES = {
    ...types('DELETESCHEDULE'),
}
export const DELETESCHEDULE_ACTIONS = {
    ...actions('DELETESCHEDULE'),
}